import { ReactNode } from "react";

type RoundedContainerProps = {
  children: ReactNode,
  title?: ReactNode,
  subheading?: ReactNode
}

export default function RoundedContainer({ children, title, subheading }: RoundedContainerProps) {
  return <div className="tw-p-4 md:tw-p-12 rounded-3 tw-max-w-screen-lg dark:tw-text-slate-100 tw-mx-auto tw-min-h-screen">
    {title && <h1 className="tw-font-semibold tw-text-3xl tw-mb-3">{title}</h1>}
    {subheading && <p className="tw-font-light tw-text-xl tw-mb-3">{subheading}</p>}
    {children}
  </div>
}